import { DataStore, TestStore } from '../model';

let store;

try {
  store = new DataStore(
    sessionStorage,
    x => JSON.stringify( x ),
    x => !x && x !== null ? undefined : JSON.parse( x )
  );
} catch ( ex ) {
  console.warn( 'SessionStorage could not be found, using TestStore instead' );
  store = new DataStore(
    new TestStore(),
    null,
    null
  );
}

export const sessionStore = store;


